export default __webpack_public_path__ + "static/media/confirmation.e4f6e647.png";